import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { Icon, Tag } from 'antd';
import { get } from 'lodash';
import { LeadCalendarIcon } from '~/_shared/components/LeadCalendarIcon';
import { formatDate, formatCurrency, hasCadence, hasValue, hasIcon } from './utils';
import {
  Container,
  Content,
  MainContent,
  LeadInfo,
  DateContainer,
  CalendarIcon,
  Date,
  LeadName,
  Value,
  CadenceContainer,
  PriorityIndicator,
} from './styles';

const LeadInfoSection = ({ item }) => (
  <LeadInfo>
    <DateContainer>
      <CalendarIcon />
      <Date>{formatDate(item.created_at)}</Date>
      {item.updated_at && item.updated_at !== item.created_at && (
        <>
          <span style={{ margin: '0 4px', color: '#999' }}>|</span>
          <Icon type="edit" style={{ color: '#666', fontSize: '10px' }} />
          <Date>{formatDate(item.updated_at)}</Date>
        </>
      )}
    </DateContainer>
    <LeadName>
      {hasIcon(item) && <Icon type={item.icon} />}
      {item.name}
      {item.additional_data && (item.additional_data.source === 'apify' || item.additional_data.apify_integration_id) && (
        <Icon
          type="thunderbolt"
          theme="filled"
          style={{ marginLeft: 6, color: '#FF7A00', fontSize: 12 }}
          title="Capturado automaticamente pela integração Apify"
        />
      )}
    </LeadName>
    {hasValue(item) && (
      <Value>{formatCurrency(item.value)}</Value>
    )}
  </LeadInfo>
);

const CadenceSection = ({ item }) => {
  if (!hasCadence(item)) return null;
  
  return (
    <CadenceContainer>
      {item.cadence.map((step, index) => (
        <Tag key={index} color={step.color} />
      ))}
    </CadenceContainer>
  );
};

const DraggableCard = ({ item, showDrawer, provided, snapshot }) => {
  const { innerRef, draggableProps, dragHandleProps } = provided;
  const { isDragging } = snapshot;
  const isRevised = get(item, 'additional_data.is_revised', false);

  return (
    <Container
      ref={innerRef}
      {...draggableProps}
      {...dragHandleProps}
      isDragging={isDragging}
      isRevised={isRevised}
      onClick={() => showDrawer(item)}
    >
      <PriorityIndicator priority={item.priority} />
      <Content>
        <MainContent>
          <LeadInfoSection item={item} />
          <LeadCalendarIcon item={item} />
        </MainContent>
        <CadenceSection item={item} />
      </Content>
    </Container>
  );
};

var LeadCardComponent = function(props) {
  var item = props.item;
  var index = props.index;
  var showDrawer = props.showDrawer;

  if (!item) return null;

  return (
    <Draggable draggableId={String(item.id)} index={index}>
      {(provided, snapshot) => (
        <DraggableCard
          item={item}
          showDrawer={showDrawer}
          provided={provided}
          snapshot={snapshot}
        />
      )}
    </Draggable>
  );
};

// Memoize to prevent re-renders when parent updates but item hasn't changed
export var LeadCard = React.memo(LeadCardComponent, function(prevProps, nextProps) {
  return prevProps.item.id === nextProps.item.id &&
         prevProps.item.updated_at === nextProps.item.updated_at &&
         prevProps.index === nextProps.index;
});
